type MacDeviceType = "gateway" | "valve";

const NON_HEX = /[^0-9a-fA-F]/g;

/** Gateways display their MAC as colon-separated lowercase pairs, valves as bare uppercase hex. */
export const formatMacInput = (raw: string, type: MacDeviceType): string => {
  if (type === "valve") return raw.replace(NON_HEX, "").toUpperCase().slice(0, 16);

  const hex = raw.replace(NON_HEX, "").toLowerCase().slice(0, 12);
  return (hex.match(/.{1,2}/g) ?? []).join(":");
};

export const macInputMaxLength = (type: MacDeviceType): number => (type === "gateway" ? 17 : 16);

export type { MacDeviceType };
